export const objectToMap = (object) => new Map(Object.entries(object))

export const deleteManyFieldsInMapAndGetNewMap = (mapItem, fields) => {
  const newMapItem = new Map(mapItem)

  fields.forEach((field) => {
    newMapItem.delete(field)
  })

  return newMapItem
}
